import {useEffect, useState} from 'react'
import {Nullable} from '../../../Common/TypeHelper'
import {useScriptElement} from './UseScriptElement'

export type TokenResponse = {
  resultCode: string
  tokenObject: {
    maskedCardNo: string,
    toBeExpiredAt: string,
    isSecurityCodeSet: boolean,
    token: string[]
  },
}

export type CardInfo = {
  tokennumber: number
  cardno: string
  expire: string
  securitycode: string
  holdername: string
}

export type Gmo = {
  init: (shopCode: string) => void,
  getToken: (cardInfo: CardInfo, callback: (result: TokenResponse) => void) => void
}

export const useGmo = (src: string): [boolean, Nullable<ErrorEvent>, Nullable<Gmo>] => {
  const [multipayment, setMultipayment] = useState<Gmo | null>(null)
  const [loading, error] = useScriptElement(src)

  useEffect(() => {
    if (!loading && !error) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setMultipayment(Multipayment)
    }
  }, [loading, error])

  return [loading, error, multipayment]
}
